export const GET_USER_INFO_SUCCESS = "GET_USER_INFO_SUCCESS"

export const CHANGE_SELECTED_CARD = "CHANGE_SELECTED_CARD"